import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { GetListEducationalStatusResponse } from "./type";
import apiRequest from "../../Utils/apiRequest";
import { apiUrl } from "../../config";
import { Form, useParams } from "react-router-dom";
import { GetAdvertDto } from "./type";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { FormikHelpers } from "formik";
import axios from "axios";
import { CreateCandidateRequest } from "./type";
import {
  showErrorToast,
  showSuccessToast,
} from "../../components/CustomNotification";
import CustomModal from "../../components/CustomModal";
import KvkkModal from "../applicationFormInternalAnnoucment/kvkkModal";

const ApplicationFormInternalAdvertOwnApp = () => {
  const { t } = useTranslation();
  const validationSchema = Yup.object({
    candidatesName: Yup.string().required(t("Ad alanı zorunludur")),
    candidatesSurname: Yup.string().required(t("Soyad alanı zorunludur")),
    candidatesGsm: Yup.string().required(
      t("Telefon numarası alanı zorunludur")
    ),
    candidatesEmail: Yup.string()
      .email(t("Geçerli bir email adresi giriniz"))
      .required(t("Email alanı zorunludur")),
    educationalStatusId: Yup.number().required(
      t("Eğitim durumu alanı zorunludur")
    ),
  });
  const [isChecked, setIsChecked] = useState(false);
  const [educationData, setEducationData] = useState<
    GetListEducationalStatusResponse[]
  >([]);
  const [organizationData, setOrganizationData] = useState<any>();
  const [kvkkModalOpen, setKvkkModalOpen] = useState(false);
  const [data, setData] = useState<GetAdvertDto>();
  const [standartHr, setStandartHr] = useState<any>();

  const { advertId } = useParams();
  const { organizationId } = useParams();

  const getOrganizationData = async () => {
    try {
      const response = await apiRequest(
        "GET",
        `${apiUrl}Organization/GetEntityByUID?OrganizationUlid=${organizationId}`,
        ""
      );
      setOrganizationData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getEducationData = async () => {
    try {
      const response = await apiRequest(
        "GET",
        `${apiUrl}EducationalStatus/GetList`,
        ""
      );
      setEducationData(response.data);
    } catch (error) {}
  };

  const getAnnoucmentData = async () => {
    try {
      const response = await apiRequest(
        "GET",
        `${apiUrl}Advert/getExternalEntityByUID?UID=${advertId}`,
        ""
      );
      setData(response.data);
      console.log("announceData", response.data.positionId);
    } catch (error) {
      console.log(error);
    }
  };
  const getStandartHr = async () => {
    try {
      const response = await apiRequest(
        "GET",
        `${apiUrl}Organization/GetStandartHr`,
        ""
      );
      console.log("standartHr", response);
      setStandartHr(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEducationData();
    getAnnoucmentData();
    getOrganizationData();
    getStandartHr();
  }, []);

  const fullName = organizationData?.employeeNameSurname || "";
  const [name, ...surname] = fullName.split(" ");

  const formik = useFormik<CreateCandidateRequest>({
    initialValues: {
      candidatesName: name || "",
      candidatesSurname: surname.join(" ") || "",
      candidatesGsm: "",
      candidatesEmail: organizationData?.email || "",
      educationalStatusId: 0,
      platformId: null,
      positionId: data?.positionId || 0,
      desciription: "",
      interviewDate: null,
      organizationId : null,
      // candidateInterviewProcessId: 0,
      cv: new File([], ""),
      candidateLanguageJson: [] as Array<{
        LanguageId: number;
        LanguageLevelId: number;
      }>,
      interviewerJson: [] as Array<{ OrganizationId: number }>,
      isInternalAdvert: false,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (
      values: CreateCandidateRequest,
      { setSubmitting }: FormikHelpers<CreateCandidateRequest>
    ) => {
      const formData = new FormData();

      // Append simple fields
      formData.append("candidatesName", values.candidatesName);
      formData.append("candidatesSurname", values.candidatesSurname);
      formData.append("candidatesGsm", values.candidatesGsm);
      formData.append("candidatesEmail", values.candidatesEmail);
      formData.append(
        "educationalStatusId",
        values.educationalStatusId.toString()
      );
      formData.append("platformId", "0");
      formData.append("positionId", values.positionId.toString());
      formData.append("desciription", values.desciription);
      formData.append("isInternalAdvert", "true");
      formData.append(
        "interviewDate",
        values.interviewDate ? new Date(values.interviewDate).toISOString() : ""
      );

      // Append file
      if (values.cv) {
        formData.append("cv", values.cv);
      }

      // Append interviewerJson array
      formData.append(
        "candidateLanguageJson",
        JSON.stringify(values.candidateLanguageJson)
      );

      // Append interviewerJson array as a single JSON string
      formData.append(
        "interviewerJson",
        JSON.stringify([{ OrganizationId: standartHr.organizationId }])
      );

      try {
        await axios({
          method: "POST",
          url: `${apiUrl}Candidate/CreateCandidate`,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "X-Spectrum-Header": localStorage.getItem("language"),
          },
        });
        showSuccessToast(t("Başarılı bir şekilde başvurdunuz."));
      } catch (error: any) {
        showErrorToast(t(error?.response?.data?.message) || "Bir hata oluştu.");
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container maxWidth="sm">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              padding: 4,
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: "#fff",
            }}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
              İlan Başvurusu
            </Typography>

            {/* Name */}
            <TextField
              fullWidth
              size="small"
              value={formik.values.candidatesName}
              name="candidatesName"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.candidatesName &&
                Boolean(formik.errors.candidatesName)
              }
              helperText={
                formik.touched.candidatesName && formik.errors.candidatesName
              }
              InputProps={{
                readOnly: true,
              }}
              label="Ad"
              placeholder="İsminiz"
              variant="outlined"
            />

            {/* Surname */}
            <TextField
              fullWidth
              size="small"
              label="Soyad"
              name="candidatesSurname"
              value={formik.values.candidatesSurname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.candidatesSurname &&
                Boolean(formik.errors.candidatesSurname)
              }
              helperText={
                formik.touched.candidatesSurname &&
                formik.errors.candidatesSurname
              }
              InputProps={{
                readOnly: true,
              }}
              placeholder="Soyadınız"
              variant="outlined"
            />

            {/* Phone */}
            <TextField
              fullWidth
              size="small"
              name="candidatesGsm"
              value={formik.values.candidatesGsm}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{
                maxLength: 11,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              onKeyDown={(e) => {
                const regex = new RegExp(/^\d$/);
                if (
                  !regex.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete" &&
                  e.key !== "ArrowLeft" &&
                  e.key !== "ArrowRight" &&
                  e.key !== "Tab"
                ) {
                  e.preventDefault();
                }
              }}
              error={
                formik.touched.candidatesGsm &&
                Boolean(formik.errors.candidatesGsm)
              }
              helperText={
                formik.touched.candidatesGsm && formik.errors.candidatesGsm
              }
              label="Telefon"
              placeholder="(5XX) XXX XXXXX"
              variant="outlined"
              type="tel"
            />

            {/* Email */}
            <TextField
              fullWidth
              size="small"
              name="candidatesEmail"
              label="Email"
              value={formik.values.candidatesEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.candidatesEmail &&
                Boolean(formik.errors.candidatesEmail)
              }
              helperText={
                formik.touched.candidatesEmail && formik.errors.candidatesEmail
              }
              placeholder="example@email.com"
              variant="outlined"
              type="email"
            />

            {/* Education */}
            <FormControl fullWidth>
              <TextField
                fullWidth
                select
                value={formik.values.educationalStatusId}
                onChange={formik.handleChange}
                name="educationalStatusId"
                onBlur={formik.handleBlur}
                error={
                  formik.touched.educationalStatusId &&
                  Boolean(formik.errors.educationalStatusId)
                }
                helperText={
                  formik.touched.educationalStatusId &&
                  formik.errors.educationalStatusId
                }
                size="small"
                label="Eğitim Durumu"
                variant="outlined"
              >
                {educationData.map((item) => (
                  <MenuItem value={item.educationalStatusId}>
                    {item.languageValue}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>

            {/* CV Upload */}
            <input
              id="cv-upload"
              type="file"
              accept=".pdf, .doc, .docx"
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (
                  file &&
                  ![
                    "application/pdf",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  ].includes(file.type)
                ) {
                  formik.setFieldError(
                    "cv",
                    "Only PDF, DOC, or DOCX files are allowed."
                  );
                } else {
                  formik.setFieldValue("cv", file ?? new File([], ""));
                  formik.setFieldError("cv", "");
                }
              }}
            />
            <TextField
              fullWidth
              label={t("Özgeçmiş")}
              value={formik.values.cv?.name || ""}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <Button
                    component="label"
                    htmlFor="cv-upload"
                    variant="contained"
                    size="small"
                    sx={{
                      borderRadius: "5px",
                      minWidth: "90px",
                      fontSize: ".75rem",
                      marginRight: "8px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#1565c0",
                      },
                    }}
                  >
                    {t("Dosya Seç")}
                  </Button>
                ),
              }}
              error={formik.touched.cv && Boolean(formik.errors.cv)}
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  // borderRadius: "1rem",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                  height: "40px",
                },
                "& .MuiOutlinedInput-input": {
                  cursor: "default",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "0.5rem",
                  padding: "4px 8px",
                  marginLeft: "4px",
                  flex: 1,
                },
              }}
            />
            <Typography
              variant="caption"
              style={{
                color: "#f44336",
                fontSize: "0.75rem",
                display: "block",
                marginTop: "4px",
                marginLeft: "14px",
              }}
            >
              {formik.touched.cv && formik.errors.cv?.toString()}
            </Typography>

            {/* Privacy Agreement */}
            <FormControlLabel
              control={
                <Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} />
              }
              label={
                <Typography variant="body2">
                  Kişisel verilerin işlenmesine ilişkin{" "}
                  <b>aydınlatma metnini</b> kabul ediyor musunuz? Aydınlatma
                  metnine erişmek için <button type="button" onClick={() => setKvkkModalOpen(true)} style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>tıklayınız</button>.
                </Typography>
              }
            />
             <CustomModal
              isOpen={kvkkModalOpen}
              size="xs"
              setIsOpen={setKvkkModalOpen}
              title="KVKK Metni"
              content={<KvkkModal/>}
            />


            {/* Submit Button */}
            <Box sx={{ textAlign: "center" }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!isChecked || formik.isSubmitting || !formik.values.candidatesName || !formik.values.candidatesSurname || !formik.values.candidatesGsm || !formik.values.candidatesEmail || !formik.values.educationalStatusId || !formik.values.cv}
              >
                Başvur
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
    </form>
  );
};

export default ApplicationFormInternalAdvertOwnApp;
